module.exports = __webpack_public_path__ + "static/media/fitbit-app-icon-square.a51e8530.png";